<template>
  <v-container :class="outerClasses">
    <v-layout>
      <v-flex>
        <slot></slot>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Content',
  props: ['title', 'titleRight', 'minHeight', 'noMargin', 'linkRight'],
  computed: {
    outerClasses: function () {
      return this.noMargin === 'true' ? 'container fluid py-2 px-0' : 'container fluid py-2 px-3'
    }
  },
  methods: {
    linkRightClick: function () {
      this.$router.push({name: this.linkRight})
    }
  }
}
</script>

<style scoped>
  .panelContainer {
    background-color: white;
    border: 1px solid #DDDDDD;
    border-radius: 3px;
  }
  .panelTitle {
    font-weight: bold;
    font-size: 12pt;
    font-style: normal;
    color: #455A64;
    border-bottom: 1px solid #455A64;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Content.vue